import React, {useState, useRef} from 'react'
import {Header, Button, Form, Search, Divider, Checkbox} from 'semantic-ui-react'
import useSWR  from 'swr'
import Dialog from '../../dialog'
import * as Yup from 'yup'
import {GlossaryFetcher, GlossarySave} from '../../../fetch/glossary'
import styles, {marginB4} from "../sidebar.module.scss"
import classNames from 'classnames'
import {getApiResponseErrorMessage} from "../../error"
import {fieldNames, options} from "../options"

const DataObjectDialog = ({ title, open, loading, onSubmit, onClose, item }) => {

    const initialState = {
        loading: false,
        name: '',
        definition: '',
        status: '',
        type: 'data-object',
        id: null,
    }
    const [state, setState] = useState(initialState)
    const [selected, setSelected] = useState([]);

    const loadElements = useRef(true)
    const [dataElements, setDataElements] = useState(null);

    const { data : elementList, errorElements } = useSWR(!loadElements.current ? null : `/data-element/list`, GlossaryFetcher/*, { errorRetryCount: 2 }*/)

    React.useEffect(() => {
    if(elementList && elementList.data) {
        setDataElements(elementList.data);
    } }, [elementList, item])

    React.useEffect(() => {
        if( item && item.id ) {
            if (item.dataElements && item.dataElements.length > 0) {
                const _tmpIndex =  item.dataElements.map(i => i.id);
                setSelected(item.dataElements);
                if (dataElements !== null && dataElements.length > 0) {
                    let _tmpDEl = dataElements;
                    _tmpDEl = dataElements.filter(item => _tmpIndex.indexOf(item.id) < 0);
                    setDataElements(_tmpDEl);
                }
            }
            setState( state => {
                return {
                    name: item.name,
                    definition: item.definition,
                    status: item.status,
                    id: item.id,
                    type: 'data-object',
                    dataDomain: item.dataDomain.id,
                }
            })
        }
    } , [item])

    const [errors, setError] = useState({})

    //let dataDomains = [];
    const [dataDomains, setDataDomains] = useState([]);

    const { data : domainList, error } = useSWR(`/data-domain/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if(domainList) {
            let _tmp = [];
            domainList.data && domainList.data.map((item, index) => {
                let tmp_item = {};
                tmp_item.text = item.name;
                tmp_item.value = item.id;
                _tmp.push(tmp_item);
                return null
            })
            setDataDomains(_tmp);
        }
    }, [domainList])

    const formSchema = Yup.object().shape({
        name: Yup.string().required(),
        definition: Yup.string().required(),
        dataDomain: Yup.number().required(),
        status: Yup.string().required(),
    });

    const handleInputChange = (e, {name, value}) => {

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const [value, setValue] = useState("");

    const [dataElementsSearch, setDataElementsSearch] = useState(null)

    const handleInputSearch = (e, {value}) => {
        setValue(value)
        //search in useEffects on value change
    }

    const removeElement = (e) => {
        const index = selected.indexOf(e);
        if (index > -1) {
            setSelected(selected.filter(item => {
                return item.id !== e.id;
            }));
            let _tmpDE = dataElements;
            _tmpDE.push(e)
            setDataElements(_tmpDE);
        }
    }

    React.useEffect(function() { //search: changed on value change, but also on add and remove element
        if(!value || value.trim() === " " || value.trim() === "" || value.trim() === null) {
            dataElementsSearch && setDataElementsSearch(dataElements);
        }
        else {
            let temp_results = dataElements && dataElements.filter(item => {
                return item.name.toLowerCase().includes(value.toLowerCase())
            })
            setDataElementsSearch(temp_results)
        }
    }, [value, dataElements, selected])

    const addElement = (e) => {
        let _temp = selected;
        _temp.push(e)
        setSelected(_temp);

        setDataElements(dataElements.filter(item => {
            return item.id !== e.id;
        }))
    }

    const handleOnSubmit = () => {

        setError({})

        formSchema.validate(state, {abortEarly: false}).then( data => {


            data.dataElements = selected.map(item => item.id);

            setState( state => {
                return {
                    ...state,
                    loading: true
                }
            })


            // Callback
            if (typeof onSubmit === 'function') {
                const reply = GlossarySave(`/${state.type}/save`, data)

                reply.then(res => {
                    if (res.success === true) {
                        onSubmit()
                    }
                }).catch(error => {
                    const errorFields = {}

                    for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })
                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false
                        }
                    })
                })

                setSelected([]);
                setState(state => initialState);
            }

        }).catch( errors => {
            console.log(errors)
            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)
            //errors.inner.forEach( error => errorFields[error.path] = getApiResponseErrorMessage({key: value, prefix: fieldNames[error.path]}))

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setSelected([]);
        setState(initialState);
        setValue('');
        setDataElementsSearch(null);
        setError({})
        onClose()
    }

    if(loadElements.current === false) {
        loadElements.current = true;
    }
    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {title}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Input
                                name="name"
                                error={errors.name}
                                label="Term name"
                                placeholder="Enter term name"
                                defaultValue={ item.name ? item.name : "" }
                                onChange={handleInputChange}
                            />

                            <br />


                            <Form.Select
                                name="dataDomain"
                                label="Data Domain"
                                error={errors.dataDomain}
                                placeholder="Select Data Domain"
                                options={dataDomains}
                                //clearable={true}
                                defaultValue={ item.dataDomain ? item.dataDomain.id : "" }
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />


                            <br />

                            <Form.Select
                                name="status"
                                label="Term status"
                                options={options}
                                error={errors.status}
                                placeholder="Select Status"
                                defaultValue={ item.status ? item.status : "" }
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />
                            <div style={{marginTop: "32px"}}> </div>

                            <div className={classNames(styles.panelBox, styles.marginB30)}>
                                <Header as="h5" className={marginB4}>Add Data Elements (optional)</Header>
                                <Search
                                    className={"searchNoResults"}
                                    name="searchElements"
                                    placeholder="Search Data Elements"
                                    value={value}
                                    onSearchChange={handleInputSearch}
                                />
                                {selected && selected.length > 0 &&
                                    <>
                                    {/*<p className={classNames(styles.pH, styles.marginT10, styles.marginB10)}> ADDED DATA ELEMENTS</p>*/}
                                        <div className={styles.selectedElements}>
                                        {selected.map((i, index) => {
                                            return <div  className={styles.marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {true}
                                                        label={i.name}
                                                        onClick={() => removeElement(i)} />
                                                </div>
                                        })}
                                        </div>
                                    </>}
                                {dataElementsSearch && dataElementsSearch.length > 0 &&
                                    <>
                                        <Divider horizontal>Data Elements</Divider>
                                        <div className={styles.allElements}>
                                        {dataElementsSearch.map((i, index) => {
                                            return <div  className={styles.marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {false}
                                                        label={i.name}
                                                        onClick={() => addElement(i)} />
                                                </div>
                                        })}
                                        </div>
                                    </>}
                                {(!dataElementsSearch) && dataElements && dataElements.length > 0 &&
                                    <>
                                        <Divider horizontal>Data Elements</Divider>
                                        <div className={styles.allElements}>
                                        {dataElements.map((i, index) => {
                                            return <div  className={styles.marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {false}
                                                        label={i.name}
                                                        onClick={() => addElement(i)} />
                                                </div>
                                        })}
                                        </div>
                                    </>}
                            </div>

                        </Form.Field>

                        <Form.Field>
                            <Form.TextArea
                                style = {{minHeight: "175px"}}
                                rows={0}
                                name="definition"
                                label="Term definition"
                                error={errors.definition}
                                defaultValue={ item.definition ? item.definition : "" }
                                onChange={handleInputChange}
                            />
                        </Form.Field>

                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default DataObjectDialog